module.exports = __webpack_public_path__ + "static/img/7.dcda5ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/eng/7.png
// module id = xQ4j
// module chunks = 0